<template>
  <div class="page-wrapper">
    <Tabs  v-model="current" :animated="false">
      <TabPane name="accountsreceivable" label="应收账单" v-if="mp('accountsreceivable')">
        <c1></c1>
      </TabPane>
      <TabPane name="paymentvoucher" label="缴费凭证" v-if="mp('paymentvoucher')">
        <c2></c2>
      </TabPane>
      <TabPane name="invoiceapply" label="发票申请" v-if="mp('invoiceapply')">
        <c3></c3>
      </TabPane>
      <TabPane name="specialreview" label="专票资质审核" v-if="mp('specialreview')">
        <c4></c4>
      </TabPane>
      <TabPane name="proinvoiceapply" label="业主发票申请" v-if="mp('proinvoiceapply')">
        <c5></c5>
      </TabPane>
      <TabPane name="acountlist" label="POS账户" v-if="mp('acountlist')">
        <c6></c6>
      </TabPane>
      <TabPane name="settlemanage" label="结算单" v-if="mp('settlemanage')">
        <c7></c7>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
  import C1 from '@/views/financialManagement/accountsReceivable/index'
  import C2 from '@/views/financialManagement/paymentVoucher/index'
  import C3 from '@/views/invoiceManage/invoiceApply/index'
  import C4 from '@/views/invoiceManage/specialReview/index'
  import C5 from '@/views/invoiceManage/proInvoiceApply/index'
  import C6 from '@/views/acountConfig/acountList/index'

  import C7 from '@/views/settleManage/index'
  import {mixin} from "../../mixin";


  export default {
    name:'projects',
    mixins:[mixin],
    components:{
      C1,
      C2,
      C3,
      C4,
      C5,
      C6,
      C7,
    }        ,
    data(){
      return {
        current:null
      }
    }

  }
</script>

<style scoped>

</style>
